import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {LocalDate} from '../domain/local-date.value-object';
import type {DashboardDependencies} from '../dependencies';
import {keys} from './keys';

export type GetDailyDashboardQueryDependencies = Pick<DashboardDependencies, 'controllers'>;

export interface GetDailyDashboardQueryInput extends GetDailyDashboardQueryDependencies {
  readonly date: LocalDate | null;
}

/**
 * Query factory for the daily dashboard. Loader and UI MUST share this
 * factory so the cache key matches and `useSuspenseQuery` resolves
 * synchronously after the loader's `ensureQueryData`.
 */
export const getDailyDashboardQuery = ({controllers, date}: GetDailyDashboardQueryInput) =>
  queryOptions({
    queryKey: keys.dailyDashboard(date),
    queryFn: () => controllers.dashboardController.getDaily({date}).then(unwrap),
  });
